import { IApiOptions, api } from "../../utils/api/actions";
import { Constants } from "./contstants";
import { SlateResponse, SportsResponse, SitesResponse } from "./types";

export const setSlate = (slate: SlateResponse) =>({
  type: Constants.SET_SLATE,
  payload: slate,
});

export const setDisplayedSlate = (slate: SlateResponse) =>({
  type: Constants.SET_DISPLAYED_SLATE,
  payload: slate,
});

export const setSport = (contest: SportsResponse) =>({
  type: Constants.SET_SPORT,
  payload: contest,
});

export const setSite = (site: SitesResponse) =>({
  type: Constants.SET_SITE,
  payload: site,
});

export const setType = (type: string) =>({
  type: Constants.SET_TYPE,
  payload: type,
});

export const setSelectedApp = (type: string) =>({
  type: Constants.SET_APP,
  payload: type,
});

export const setPlayerExposureCaps = (exposures: { [key: string]: number }) => ({
  type: Constants.SET_PLAYER_EXPOSURES,
  payload: exposures,
});

export const setStackExposureCaps = (exposures: { [key: string]: number }) => ({
  type: Constants.SET_STACK_EXPOSURES,
  payload: exposures,
});
export const setRemovedTeamsAction = (removedTeams: string[]) => ({
  type: Constants.SET_REMOVED_TEAMS,
  payload: removedTeams,
});
export const setBoostedTeamsAction = (boostedTeams: {[key: string]: number}) => ({
  type: Constants.SET_BOOSTED_TEAMS,
  payload: boostedTeams,
});
export const setUniqueLimit = (limit: number) => ({
  type: Constants.SET_UNIQUE_LIMIT,
  payload: limit,
});

export const setAuth = (sport: string, email: string, appName: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = '/api/auth/stripe';

  options = {
    ...options,
    route,
    params: {
      sport,
      email,
      appName
    }
  };

  return api(
    Constants.SET_AUTH, {
    ...options,
  });
};